import React from 'react';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/system';

const PageHeader = ({ title, paddingNum }) => {
    const theme = useTheme();

    return (
        <Grid
            container
            item
            sx={{
                background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary[200]})`,
                padding: paddingNum
            }}
        >
            <Grid>
                <Typography sx={{ color: '#FFFFFF', fontSize: '16px' }}>{title}</Typography>
            </Grid>
        </Grid>
    );
};

PageHeader.propTypes = {
    title: PropTypes.string,
    paddingNum: PropTypes.number
};

export default PageHeader;
